import { Link } from "@tanstack/react-router";

/**
 * Global legal footer — rendered on every page via __root.tsx.
 * Compliance requirement: educational-tools-only positioning + access to
 * Risk Disclosure, Performance Methodology, Terms, Privacy, and Support.
 */
export function SiteFooter() {
  return (
    <footer
      className="mt-auto max-w-full overflow-hidden border-t border-border/60 bg-card/30 px-4 py-6 text-center text-[11px] leading-relaxed text-muted-foreground sm:px-6"
      role="contentinfo"
    >
      <nav
        aria-label="Legal"
        className="mx-auto flex max-w-4xl flex-wrap items-center justify-center gap-x-3 gap-y-1 font-medium sm:gap-x-4"
      >
        <Link to="/performance" className="font-semibold text-primary hover:text-foreground">
          Performance Transparency
        </Link>
        <span aria-hidden>·</span>
        <Link to="/guides" className="hover:text-foreground">
          Guides
        </Link>
        <span aria-hidden>·</span>
        <Link to="/risk-disclosure" className="hover:text-foreground">
          Risk Disclosure
        </Link>
        <span aria-hidden>·</span>
        <Link to="/integrity" className="font-semibold text-primary hover:text-foreground">
          Integrity
        </Link>
        <span aria-hidden>·</span>
        <Link to="/performance-methodology" className="hover:text-foreground">
          Methodology
        </Link>
        <span aria-hidden>·</span>
        <Link to="/terms" className="hover:text-foreground">
          Terms
        </Link>
        <span aria-hidden>·</span>
        <Link to="/privacy" className="hover:text-foreground">
          Privacy Policy
        </Link>
        <span aria-hidden>·</span>
        <Link to="/support" className="hover:text-foreground">
          Contact / Support
        </Link>
      </nav>
      <div className="mx-auto mt-3 flex max-w-4xl flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px]">
        <span>
          Support:{" "}
          <a className="hover:text-foreground" href="mailto:support@forexmind.ai">
            support@forexmind.ai
          </a>
        </span>
        <span aria-hidden>·</span>
        <span>
          Billing:{" "}
          <a className="hover:text-foreground" href="mailto:billing@forexmind.ai">
            billing@forexmind.ai
          </a>
        </span>
        <span aria-hidden>·</span>
        <span>
          Legal:{" "}
          <a className="hover:text-foreground" href="mailto:legal@forexmind.ai">
            legal@forexmind.ai
          </a>
        </span>
      </div>
      <p className="mx-auto mt-3 max-w-3xl break-words">
        ForexMind AI provides educational market intelligence only. Not financial advice.
        Subscription fees are for access to educational tools. ForexMind AI is not responsible
        for trading losses or individual trading decisions.
      </p>
      <p className="mt-2">© 2026 ForexMind AI</p>
    </footer>
  );
}
